import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import cx from 'classnames';
import { Button } from 'react-bootstrap'
import { IKImage } from "imagekitio-react";
import Truncate from 'react-truncate';
import _ from 'lodash';
import styles from './toast.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import { deleteAssetMappings } from 'actions/content';
const defaultContentImage = '/public/cleverstory/v2/static/default_card.jpg';

export function SuccessToast(props) {
  return (
    <div className={cx(styles.container, styles.success)}>
      <i className={cx('cleverstory-close', styles.close)} />
      <div className={styles.message}>
        <FontAwesomeIcon icon={faCheckCircle} className={styles.icon} />
        <div className={styles.inner}>
          <div className={styles.heading}>{props.heading}</div>
          <div className={cx(styles.description, { [styles.link]: props.link != null })}>{props.description}</div>
        </div>
      </div>
    </div>
  )
}

SuccessToast.defaultProps = {
  heading: "Success",
  description: ""
}


export function FailureToast(props) {
  return (
    <div className={cx(styles.container, styles.failure)}>
      <i className={cx('cleverstory-close', styles.close)} />
      <div className={styles.message}>
        <FontAwesomeIcon icon={faTimesCircle} className={styles.icon} />
        <div className={styles.inner}>
          <div className={styles.heading}>{props.heading}</div>
          <div className={cx(styles.description, { [styles.link]: props.link != null })}>{props.description}</div>
        </div>
      </div>
    </div>
  )
}

FailureToast.defaultProps = {
  heading: "Success",
  description: ""
}

export function DuplicateAssetToast({ storyboard, duplicate, closeToast }) {
  const dispatch = useDispatch();

  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const id = _.get(duplicate, 'id', null);
  const duplicateAsset = _.get(duplicate, 'duplicateAsset', null);
  const duplicateAssetId = _.get(duplicate, 'duplicateAsset.id', null);
  const similarAsset = _.get(duplicate, 'similarAsset', null);
  const icon = _.get(duplicate, 'duplicateAsset.icon.key', null);

  const skipUpload = () => {
    var request = {
      mappings: [duplicateAssetId],
      storyboard: _.get(storyboard, 'id')
    }
  
    dispatch(deleteAssetMappings(request));
    closeToast(id);
  }

  return (
    <div className={cx(styles.container, styles.duplicateToast)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {!isHovered &&
        <div className={styles.assetInfoContainer}>
          <IKImage
            className={styles.icon}
            path={icon || defaultContentImage}
          />
          <div className={styles.assetInfo}>
              <span className={styles.name}>
                <Truncate width={200} lines={1}> {_.get(duplicateAsset, 'name', '')}</Truncate>
              </span>
              <span>already exist as</span>
              <span className={styles.name}>
                <Truncate width={200} lines={1}> {_.get(similarAsset, 'asset.name', '')}</Truncate>
              </span>
          </div>
        </div>
      }
      {isHovered &&
        <div className={styles.actionsGroup}>
          <Button className={styles.actionBtn} variant='primary' onClick={() => closeToast(id)}>
            Keep Duplicate
          </Button>
          <Button className={styles.actionBtn} variant='primary' onClick={() => skipUpload()}>
            Skip Upload
          </Button>
        </div>
      }
      <div className={styles.closeButton} onClick={() => closeToast(id)}><i className={cx("cleverstory-close")} /></div>
    </div>
  )
}

export function WarningToast(props) {
  return (
    <div className={cx(styles.container, styles.warning)}>
      <i className={cx('cleverstory-close', styles.closeWarning)} />
      <div className={styles.message}>
        <FontAwesomeIcon icon={faQuestionCircle} className={styles.icon} />
        <div className={styles.inner}>
          <div className={styles.heading}>{props.heading}</div>
          <div className={cx(styles.descriptionWarning, { [styles.link]: props.link != null })}>{props.description}</div>
        </div>
      </div>
    </div>
  )
}

WarningToast.defaultProps = {
  heading: "",
  description: ""
}